import {
  ADD,
  REMOVE,
} from './mutation-types';

export default {
  [ADD](state, payload) {
    state.items = payload;
  },
  [REMOVE](state, payload) {
    state.items = payload;
  },
};
